// Store locator search: limit Google address suggestions to the countries we
// trade in (GW-714): South Africa, Lesotho, Eswatini, Namibia, Botswana, Zimbabwe.
//
// The native store locator (core storefront.content.min.js, not ours to edit)
// builds a LEGACY google.maps.places.Autocomplete on .sl-search-input with no
// country restriction. The legacy widget caps componentRestrictions at FIVE
// countries and silently ignores the rest (verified: a 6th code is dropped), so
// it can't express our six. The new Places API (AutocompleteSuggestion) takes up
// to 15 region codes.
//
// So, on /store-locator only, google.maps.places.Autocomplete is wrapped: for the
// store-locator input it returns a small stand-in that fetches suggestions from
// the new API, renders its own dropdown, and fires 'place_changed' with a
// getPlace() shaped like the legacy one ({ geometry: { location } }), which is
// all the native code reads. Every other Autocomplete (checkout/address forms)
// gets Google's original untouched. If the new API is unavailable it falls back
// to the legacy widget restricted to the first five countries.

var REGION_CODES = ['za', 'ls', 'sz', 'na', 'bw', 'zw'];
var MAX_LEGACY_COUNTRIES = 5;
var DEBOUNCE_MS = 180;

function isStoreLocatorInput(el) {
  return !!(el && el.classList && el.classList.contains('sl-search-input'));
}

function ensureStyles() {
  if (document.getElementById('pf-sl-ac-css')) return;
  var st = document.createElement('style');
  st.id = 'pf-sl-ac-css';
  // px, not rem: the storefront sets html{font-size:10px}. Mirrors Google's
  // .pac-container look so it reads as the same control.
  st.textContent =
    '.pf-sl-ac{position:absolute;z-index:1060;background:#fff;border-radius:0 0 4px 4px;' +
    'box-shadow:0 2px 6px rgba(0,0,0,.3);font-family:inherit;overflow:hidden;box-sizing:border-box}' +
    '.pf-sl-ac[hidden]{display:none}' +
    '.pf-sl-ac-item{display:flex;align-items:baseline;gap:6px;padding:8px 12px;font-size:13px;line-height:1.35;' +
    'color:#5f6368;cursor:pointer;border-top:1px solid #e6e6e6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.pf-sl-ac-item:first-child{border-top:0}' +
    '.pf-sl-ac-item.is-active,.pf-sl-ac-item:hover{background:#eef1fb}' +
    '.pf-sl-ac-main{color:#202124;font-weight:600}' +
    '.pf-sl-ac-foot{padding:4px 8px;text-align:right;border-top:1px solid #e6e6e6}' +
    '.pf-sl-ac-foot img{height:14px;vertical-align:middle}';
  (document.head || document.documentElement).appendChild(st);
}

function escHtml(s) {
  return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function makeStandIn(g) {
  var places = g.maps.places;

  function StoreLocatorAutocomplete(input) {
    g.maps.MVCObject.call(this);
    var self = this;
    self._input = input;
    self._place = null;
    self._items = [];
    self._active = -1;
    self._seq = 0;
    self._timer = null;
    self._token = null;

    ensureStyles();
    input.classList.add('pac-target-input');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('data-pf-ac', '1');

    var box = document.createElement('div');
    box.className = 'pf-sl-ac pac-container';
    box.id = 'pf-sl-ac-' + Math.random().toString(36).slice(2, 8);
    box.setAttribute('role', 'listbox');
    box.hidden = true;
    document.body.appendChild(box);
    input.setAttribute('aria-controls', box.id);
    self._box = box;

    input.addEventListener('input', function () { self._schedule(); });
    input.addEventListener('keydown', function (e) { self._onKey(e); });
    input.addEventListener('blur', function () { setTimeout(function () { self._close(); }, 150); });
    // mousedown (not click) so the input's blur doesn't close the list first.
    box.addEventListener('mousedown', function (e) {
      var row = e.target && e.target.closest && e.target.closest('.pf-sl-ac-item');
      if (!row) return;
      e.preventDefault();
      self._select(Number(row.getAttribute('data-i')));
    });
    var reposition = function () { if (!box.hidden) self._position(); };
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);
  }
  StoreLocatorAutocomplete.prototype = Object.create(g.maps.MVCObject.prototype);
  StoreLocatorAutocomplete.prototype.constructor = StoreLocatorAutocomplete;

  // Legacy API surface the native code (or anything else) might call.
  StoreLocatorAutocomplete.prototype.getPlace = function () { return this._place || {}; };
  ['setBounds', 'setComponentRestrictions', 'setFields', 'setOptions', 'setTypes'].forEach(function (m) {
    StoreLocatorAutocomplete.prototype[m] = function () { /* restriction is fixed */ };
  });
  StoreLocatorAutocomplete.prototype.getBounds = function () { return undefined; };

  StoreLocatorAutocomplete.prototype._schedule = function () {
    var self = this;
    clearTimeout(self._timer);
    var q = (self._input.value || '').trim();
    if (q.length < 2) { self._close(); return; }
    self._timer = setTimeout(function () { self._fetch(q); }, DEBOUNCE_MS);
  };

  StoreLocatorAutocomplete.prototype._fetch = function (q) {
    var self = this;
    var seq = ++self._seq;
    if (!self._token) self._token = new places.AutocompleteSessionToken();
    places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
      input: q,
      includedRegionCodes: REGION_CODES,
      sessionToken: self._token,
    }).then(function (res) {
      if (seq !== self._seq) return; // a newer keystroke won
      var list = (res && res.suggestions) || [];
      self._items = list.map(function (s) { return s.placePrediction; }).filter(Boolean).slice(0, 5);
      self._render();
    }).catch(function () {
      if (seq === self._seq) self._close();
    });
  };

  StoreLocatorAutocomplete.prototype._render = function () {
    var self = this;
    if (!self._items.length) { self._close(); return; }
    self._active = -1;
    var html = self._items.map(function (p, i) {
      var main = p.mainText ? p.mainText.text : (p.text ? p.text.text : '');
      var sec = p.secondaryText ? p.secondaryText.text : '';
      return '<div class="pf-sl-ac-item pac-item" role="option" id="' + self._box.id + '-' + i + '" data-i="' + i + '">' +
        '<span class="pf-sl-ac-main">' + escHtml(main) + '</span>' +
        (sec ? '<span>' + escHtml(sec) + '</span>' : '') + '</div>';
    }).join('');
    self._box.innerHTML = html +
      '<div class="pf-sl-ac-foot"><img src="https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3_hdpi.png" alt="Powered by Google"></div>';
    self._position();
    self._box.hidden = false;
    self._input.setAttribute('aria-expanded', 'true');
  };

  StoreLocatorAutocomplete.prototype._position = function () {
    var r = this._input.getBoundingClientRect();
    this._box.style.left = (r.left + window.pageXOffset) + 'px';
    this._box.style.top = (r.bottom + window.pageYOffset) + 'px';
    this._box.style.width = r.width + 'px';
  };

  StoreLocatorAutocomplete.prototype._close = function () {
    clearTimeout(this._timer);
    this._seq++;
    this._box.hidden = true;
    this._active = -1;
    this._input.setAttribute('aria-expanded', 'false');
    this._input.removeAttribute('aria-activedescendant');
  };

  StoreLocatorAutocomplete.prototype._highlight = function (i) {
    var rows = this._box.querySelectorAll('.pf-sl-ac-item');
    if (!rows.length) return;
    this._active = (i + rows.length) % rows.length;
    for (var k = 0; k < rows.length; k++) rows[k].classList.toggle('is-active', k === this._active);
    this._input.setAttribute('aria-activedescendant', rows[this._active].id);
  };

  StoreLocatorAutocomplete.prototype._onKey = function (e) {
    if (this._box.hidden) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); this._highlight(this._active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this._highlight(this._active - 1); }
    else if (e.key === 'Escape') { this._close(); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      this._select(this._active >= 0 ? this._active : 0);
    }
  };

  StoreLocatorAutocomplete.prototype._select = function (i) {
    var self = this;
    var pred = self._items[i];
    if (!pred) return;
    self._input.value = pred.text ? pred.text.text : self._input.value;
    self._close();
    var place = pred.toPlace();
    self._token = null; // a selection ends the billing session
    place.fetchFields({ fields: ['location', 'displayName', 'formattedAddress'] }).then(function () {
      self._place = place.location
        ? { geometry: { location: place.location }, name: place.displayName || '', formatted_address: place.formattedAddress || '' }
        : { name: self._input.value };
      g.maps.event.trigger(self, 'place_changed');
    }).catch(function () {
      self._place = { name: self._input.value };
      g.maps.event.trigger(self, 'place_changed');
    });
  };

  return StoreLocatorAutocomplete;
}

function wrap(g) {
  var places = g.maps.places;
  var Orig = places.Autocomplete;
  if (!Orig || Orig.__pfWrapped) return true;
  var newApi = !!(places.AutocompleteSuggestion && places.AutocompleteSessionToken && g.maps.MVCObject);
  var StandIn = newApi ? makeStandIn(g) : null;

  function Wrapped(input, opts) {
    if (isStoreLocatorInput(input)) {
      if (StandIn) return new StandIn(input);
      var o = Object.assign({}, opts || {});
      o.componentRestrictions = { country: REGION_CODES.slice(0, MAX_LEGACY_COUNTRIES) };
      return new Orig(input, o);
    }
    return new Orig(input, opts);
  }
  Wrapped.prototype = Orig.prototype;
  Wrapped.__pfWrapped = true;
  try { places.Autocomplete = Wrapped; } catch (e) { return false; }
  return true;
}

/** Install before the native store locator initialises (DOM ready). Our bundle
 *  is deferred, so it normally runs first; the poll covers a late places lib. */
export function installStoreLocatorAutocomplete() {
  var tries = 0;
  (function attempt() {
    var g = window.google;
    if (g && g.maps && g.maps.places && g.maps.places.Autocomplete) { wrap(g); return; }
    if (++tries < 200) setTimeout(attempt, 25);
  })();
}
